import React from "react";

interface InputFieldProps {
  label: string;
  value: string;
  onChange: (value: string) => void;
  skipValidation?: boolean;
  min?: number;
  max?: number;
  /** Optional test ID for automation */
  'data-testid'?: string;
}

const InputField: React.FC<InputFieldProps> = ({
  label,
  value,
  onChange,
  skipValidation = false,
  min,
  max,
  'data-testid': testid,
}) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.value;

    if (skipValidation) {
      onChange(String(newValue));
      return;
    }

    if (newValue === '') {
      onChange('');
      return;
    }

    const numValue = parseFloat(newValue);
    if (isNaN(numValue)) return;
    if (numValue < 0) return;
    if (min !== undefined && numValue < min) return;
    if (max !== undefined && numValue > max) return;

    onChange(String(newValue));
  };

  return (
    <div className="mb-3 sm:mb-4">
      <label className="block text-foreground font-medium mb-1 sm:mb-2 text-xs sm:text-sm md:text-base">{label}</label>
      <input
        type="number"
        value={value}
        onChange={handleChange}
        min={min}
        max={max}
        data-testid={testid}
        className="w-full px-3 py-1.5 sm:px-4 sm:py-2 bg-yellow-100 text-yellow-800 border border-yellow-300 rounded-md text-xs sm:text-sm md:text-base transition-all duration-200 focus:ring-2 focus:ring-yellow-400 focus:border-yellow-400 focus:outline-none hover:border-yellow-400"
        placeholder={label}
      />
    </div>
  );
};

export default InputField;
